import(/* webpackMode: "eager", webpackExports: ["DiscoverSkeletonCard"] */ "/app/components/DiscoverCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Skeleton"] */ "/app/node_modules/@heroui/skeleton/dist/index.mjs");
